import React from 'react';
import { Link, useLocation } from "react-router-dom";
import * as FeatherIcon from 'react-feather';
import { useUser } from '../../../context/UserContext';

export default function ProfileSidebar() {
  var pathname = useLocation().pathname;
  var progress_bar_width = 33;
  const { user } = useUser();
  
  if (pathname === '/user_profile/profile'){
    progress_bar_width = 33;
  }else if(pathname === '/user_profile/business_segment'){
    progress_bar_width = 66;
  }else if(pathname === '/user_profile/company_profile'){
    progress_bar_width = 100;
  }
  return (
    <div>  
      <div className='progress_bar_block mb-4'>
        <h5 className='progress_head'>Complete admin profile</h5>
        <div className="progress">
          <div className="progress-bar bg-success" style={{width:progress_bar_width+'%'}}></div>
        </div>
      </div>

      <ul className='profile_sidebar_ul'>
        <li className={`profile_sidebar_li ${pathname === '/user_profile/profile' ? 'active' : ''}`}>
          <Link className='link_sidebar' to={{ pathname: "/user_profile/profile" }}><FeatherIcon.User className='img_trend' /> Enter Basic Details</Link>
        </li>

        {user?.role_key !== "CLIENT_EMPLOYEE" && <li className={`profile_sidebar_li ${pathname === '/user_profile/business_segment' ? 'active' : ''}`}>
          <Link className='link_sidebar' to={{ pathname: "/user_profile/business_segment" }}><FeatherIcon.Box className='img_trend' /> Enter Product Details</Link>
        </li>}

        <li className={`profile_sidebar_li ${pathname === '/user_profile/company_profile' ? 'active' : ''}`}>
          <Link className='link_sidebar' to={{ pathname: "/user_profile/company_profile" }}><FeatherIcon.Briefcase className='img_trend' /> Select Accounts</Link>
        </li>
        {/* <li className='profile_sidebar_li'><a href="#" className='link_sidebar'><img src="/img/icons/profile/industry.png" className="img_trend" alt="profile"/> Enter business segments</a></li> */}
      </ul>
    </div>
  )
}
